import useKey from './useKey';

export default function useEsc(callback) {
    useKey(event => event.keyCode === 27 && callback(event));
}
